// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__o+CCE"};